export default {
  INCREMENT_COUNTER(state) {
    state.count = state.count + 1
  },
}
